<script>
	import ApiClientCore from './core'
	import Mixins from './mixins';
	import * as MutationTypes from '@/store/mutation-types'

	export default {
		name: 'api-client',
		extends: ApiClientCore,
		mixins: Mixins,
		methods: {
			errorHandler(error) {
				this.$store.commit(MutationTypes.SET_ERROR, error);
			},
		}
	}
</script>
